<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 7725 7725"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="3862" cy="3862" r="3862"/>
  <circle class="fil1" cx="3862" cy="3083" r="1586"/>
  <polygon class="fil0" points="3889,3473 4873,2203 3454,2957 "/>
  <rect class="fil1" x="3609" y="4287" width="507" height="2040" rx="253" ry="92"/>
  <rect class="fil1" transform="matrix(3.27003E-14 -1.2347 0.501712 1.32876E-14 2716.02 6326.58)" width="410" height="4571" rx="205" ry="205"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'PressureMeter',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#56D6D1}
</style>
